import { ColDef } from 'ag-grid-community';
import { useMediaQuery, useTheme } from '@mui/material';

type ColumnConfig = {
  [key: string]: string;
};

type RowDataType = {
  id: string;
};

export const useAgGridColumns = (
  fieldAndHeaderNames: ColumnConfig,
  mobileColumns: string[] = [],
  actions?: {
    cellRenderer: (params: {
      data: RowDataType;
      row: { id: string };
    }) => React.ReactNode;
  }
): ColDef[] => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return Object.entries(fieldAndHeaderNames).map(([field, headerName]) => {
    return {
      field,
      headerName,
      hide:
        isMobile && mobileColumns.length > 0 && !mobileColumns.includes(field),
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      ...(actions &&
        field === 'actions' && {
          cellRenderer: actions.cellRenderer,
        }),
    };
  });
};
